<template>
    <div class="d-flex align-items-center">
        <div class="w-100">
            <bar-metrics class="sites-metrics" :data="data" :colors="colors" :show-bars="showBars"
                         type="public"></bar-metrics>
        </div>
    </div>
</template>

<style lang="sass" scoped>
    .sites-metrics
        ::v-deep
        .progress
            height: 20px
            border-radius: 0
</style>

<script>
    export default {
        props: {
            showBars: {default: true},
            data: {default: []}
        },

        data() {
            return {
                options: {
                    responsive: false,
                    legend: {
                        display: false
                    },
                    cutoutPercentage: 70
                }
            };
        },

        computed: {
            colors() {
                return this.data.map(data => data.color);
            }
        },
    };
</script>
